import React from 'react';
import { useDispatch } from 'react-redux';
import { Resizable } from 'react-resizable';
import { setHeaderWidthLoadDetails } from '../../../../../store/actions/callCheckLoadsActions/callCheckLoads';
import { CallCheckLoadsSelectors } from '../../../../../store/selectors/callCheckLoadsSelectors';

const HeaderCell = ({ ind, resource, type }) => {
  const dispatch = useDispatch();
  const { state } = CallCheckLoadsSelectors();
  let data = '';
  if (type === 'pick') {
    data = state[resource].detailsPageHeadersPick[ind]
  } else {
    data = state[resource].detailsPageHeadersDrop[ind]
  }

  let cellStyle = {
    maxWidth: `${data.width}px`,
    width: `${data.width}px`,
    minWidth: `${data.width}px`,
  };

  const onResize = s => {
    dispatch(setHeaderWidthLoadDetails(resource, ind, s.size.width, type));
  };

  const headerCall = (
    <div className='table-header-cell' style={cellStyle}>
      <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>{data.title}</div>
    </div>
  );

  const resizableHeaderCall = (
    <Resizable
      width={data.width}
      height={0}
      handle={
        <span
          className='react-resizable-handle'
          onClick={e => {
            e.stopPropagation();
          }}
        />
      }
      onResize={(_, s) => onResize(s)}
      draggableOpts={{ enableUserSelectHack: false }}>
      {headerCall}
    </Resizable>
  );

  return resizableHeaderCall;
};

export default React.memo(HeaderCell);
